import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  const getCategoryIcon = (category) => {
    const icons = {
      'All': 'Grid',
      'Full-Stack': 'Layers',
      'Performance': 'Zap',
      'Architecture': 'Box',
      'DevOps': 'Server',
      'Frontend': 'Layout',
      'Backend': 'Database'
    };
    return icons?.[category] || 'FileText';
  };

  return (
    <div className="flex flex-wrap gap-2 md:gap-3">
      {categories?.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-300
            ${activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
            }
          `}
        >
          <Icon name={getCategoryIcon(category)} size={16} />
          <span className="text-sm">{category}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;